/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedBlog = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsFeaturedBlog = $.extend(this, Shopify.theme.getSectionData($section));
        let $sliderEl = $section.find('[data-slider]');
      console.log("init");
        
        if ($(window).width() < 798) {
          this.createSliderMobile($sliderEl);
        }
        else{
          Shopify.theme.jsFeaturedBlog.unload($section);
        }
        $(window).on("resize", function () {
          Shopify.theme.jsFeaturedBlog.unload($section);
          if ($(window).width() < 798) {
            Shopify.theme.jsFeaturedBlog.createSliderMobile($sliderEl);
          }
        });
      },
    createSliderMobile: function ($sliderEl) {
      const slider = $sliderEl.flickity({
        lazyLoad: 1,
        imagesLoaded: true,
        groupCells: '100%',
        draggable: true,
        cellAlign: 'center',
        wrapAround: true,
        pageDots: false,
        contain: true,
        percentPosition: false,
        prevNextButtons: true,
        initialIndex: 1,
        arrowShape: arrowShape
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;